import { FC } from "react";
import BFLLink from "@repo/shared-ui/BFLLink";
import { IRelatedLinksContent } from "../../interfaces/ITradingMallContentV1.interface";
import { twMerge } from "tailwind-merge";

export interface RelatedLinksProps {
  content: IRelatedLinksContent;
}

const RelatedLinks: FC<RelatedLinksProps> = ({ content }) => {
  const { tabsList, heading } = content;

  const orderedList = tabsList?.[0]
    ? Object.entries(tabsList[0])
        .sort(([keyA], [keyB]) => {
          const numA = parseInt(keyA.replace("item", ""), 10);
          const numB = parseInt(keyB.replace("item", ""), 10);
          return numA - numB;
        })
        .map(([, value]) => value)
    : [];

  return (
    <section className={twMerge("mb-6", content.customClass ?? "")}>
      <h2 className="mb-3 text-lg font-medium leading-[22px] text-[#000000]">
        {heading ?? "Related links"}
      </h2>
      <ul className="flex-wrap text-sm md:flex">
        {orderedList.map(({ ctaText, ctaLink, ctaInNewTab }, index) => (
          <li
            className={`${
              index !== 0 ? "ml-1 border-l pl-1" : ""
            } inline-block border-gray-600 leading-[17px]`}
            key={ctaLink ?? `${ctaText}-${index}`}
          >
            <BFLLink
              href={ctaLink}
              className="text-link-primary"
              openInNewTab={ctaInNewTab === "true"}
            >
              {ctaText}
            </BFLLink>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default RelatedLinks;
